<template>
  <b-badge
    v-b-tooltip.hover
    variant="success"
    title="This feature is still under development. Please let us know what you think of it!"
  >
    beta
  </b-badge>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class BetaBadge extends Vue {}

</script>
